import axios from "@/plugins/axios";

// Pendapatan Isi Rumah Bulanan mengikut Daerah Pentadbiran & Strata.
// Combines Purata + Penengah into one daerah × strata table (Bandar / Luar Bandar
// / Jumlah per year). A negeri is required (the page defaults to Johor). Years are
// discovered server-side and returned in `data.years`; `data.purata` and
// `data.penengah` each hold rows of
// { dp, daerah, isTotal, strata:{ Bandar:{y:v}, 'Luar Bandar':{y:v}, Jumlah:{y:v} } }.
export default class daerahXstrataServices {
  // params: { NG (required), P (csv pusingan), S ("1"|"2"|"3") }
  async getDaerahStrata(params = {}) {
    const res = await axios.get(
      `${process.env.VUE_APP_API_URL}/JadualAwalan/getDaerahStrataJR2`,
      { params }
    );
    return (res.data && res.data.data) || {};
  }
}
